import img from "../US_img/4.webp"; // 🔴 adapte ton image
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsLightBox() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>LIGHT BOX</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Caisson lumineux sur mesure</h1>

          <p data-aos="fade-up">
            Le caisson lumineux US LIGHT BOX est conçu pour mettre en valeur
            vos visuels avec un éclairage homogène et performant. Fabriqué
            sur mesure, il s’adapte parfaitement aux besoins de la publicité,
            de la signalétique et de la communication corporate.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-light-box.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Light Box caisson lumineux" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US LIGHT BOX ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US LIGHT BOX est un caisson lumineux aluminium équipé de la
            technologie EDGE LED permettant une diffusion lumineuse
            parfaitement homogène sur toute la surface du visuel.
          </p>

          <p data-aos="fade-up">
            Grâce au système de jonc textile, le changement de visuel est
            rapide et sans démontage, ce qui en fait une solution idéale
            pour les environnements commerciaux et corporate.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="💡"
            title="EDGE LED performant"
            text="Éclairage homogène haute efficacité énergétique."
          />
          <Feature
            icon="🖼️"
            title="Visuels valorisés"
            text="Mise en avant optimale de vos communications."
          />
          <Feature
            icon="🔄"
            title="Changement rapide"
            text="Toile interchangeable par système de jonc."
          />
          <Feature
            icon="📐"
            title="Sur mesure"
            text="Fabrication adaptée à toutes dimensions."
          />
          <Feature
            icon="⚡"
            title="Faible consommation"
            text="Technologie LED économique et durable."
          />
          <Feature
            icon="🛠️"
            title="Installation simple"
            text="Pose rapide en mural, suspendu ou autoportant."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Caisson aluminium sur mesure</li>
          <li>Technologie EDGE LED intégrée</li>
          <li>Toile textile avec jonc silicone</li>
          <li>Diffusion lumineuse homogène</li>
          <li>Faible consommation énergétique</li>
          <li>Installation murale ou suspendue</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Signalétique",
            "Publicité",
            "Retail",
            "Centres commerciaux",
            "Showrooms",
            "Hôtels",
            "Bureaux",
            "Espaces corporate",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Mettez votre image en lumière</h2>
        <p>
          Les solutions US LIGHT BOX valorisent efficacement votre
          communication visuelle.
        </p>
        <br />
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
